var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',_vm._g({attrs:{"height":"24","width":"24","xmlns":"http://www.w3.org/2000/svg"}},_vm.$listeners),[_c('path',{attrs:{"d":"M7 5a1 1 0 0 0 0 2h8.586L5.293 17.293a1 1 0 1 0 1.414 1.414L17 8.414V17a1 1 0 1 0 2 0V6a1 1 0 0 0-1-1z","fill-rule":"evenodd"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }